<template>
    <div>
        <div v-if="!editing" :class="reactiveClass">
            <b-link title="Cliquer pour modifier" @click="edit">
                {{ displayedValue }}
            </b-link>
        </div>
        <div v-if="editing" style="width: 120px" class="ml-auto">
            <b-input-group>
                <b-input-group-prepend>
                    <b-button title="Annuler" size="sm" @click="display">
                        <i class="fas fa-fw fa-times"></i>
                    </b-button>
                </b-input-group-prepend>
                <b-input
                    v-model="form.value"
                    size="sm"
                    class="text-right"
                    :formatter="decimalString"
                    @change="update"
                />
            </b-input-group>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TableFormHandler from '../../../common/mixins/TableFormHandler'
import Formatter from '../../../common/mixins/Formatter'

export default {
    name: 'KeyFiguresHandler',

    mixins: [TableFormHandler, Formatter],

    props: {
        data: null,
        year: null,
        clientId: 0,
        type: '',
    },

    data() {
        return {
            editing: false,
            form: {
                value: null,
            },
            displayedValue: '-',
        }
    },

    created() {
        this.init()
    },

    methods: {
        init() {
            this.align = 'right'
            if (this.data !== null) {
                switch (this.type) {
                    case 'vat':
                        if (this.data.vat_base !== null) {
                            this.displayedValue = `${parseFloat(
                                this.data.vat_base
                            ).toFixed(0)} €`
                            this.form.value = parseFloat(this.data.vat_base)
                        }
                        break
                    case 'is':
                        if (this.data.taxation !== null) {
                            this.displayedValue = `${parseFloat(
                                this.data.taxation
                            ).toFixed(0)} €`
                            this.form.value = parseFloat(this.data.taxation)
                        }
                        break
                    default:
                        break
                }
            }
        },

        edit() {
            this.editing = true
        },

        display() {
            this.editing = false
        },

        async update() {
            this.form.year = this.year
            this.form.client_id = this.clientId
            switch (this.type) {
                case 'vat':
                    this.form.vat_base = this.form.value
                    break
                case 'is':
                    this.form.taxation = this.form.value
                    break
                default:
                    break
            }
            try {
                await axios.post('/keyFigures/activityTable', this.form)
                this.handleSuccess()
                this.displayedValue =
                    this.form.value === ''
                        ? '-'
                        : `${parseFloat(this.form.value).toFixed(0)} €`
                this.display()
            } catch (error) {
                this.initForm()
                this.display()
                this.handleError()
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
